import { DateTime } from 'luxon';

import getColDurationAsMs from './getColDurationAsMs';

const colDiff = (dtStart, dtEnd, dateMode, colSize) => {
  const colMs = getColDurationAsMs(dateMode);
  const diff = dtStart.diff(dtEnd).as('milliseconds');
  
  return diff * colSize / colMs;
}

export default colDiff;
